import React, {useEffect, useState} from "react";
// import {useLocation} from "react-router-dom";
import {useNetwork} from "../../helpers/useNetwork";
import queryString from 'query-string'

const withUrlParams = BaseComponent => (props) => {
    const url = new URL(window.location.href)
    const query = queryString.parse(url.search)

    // const location = useLocation();
    // const query = queryString.parse(location.search);
    const uuid = (query.uuid !== undefined) ? query.uuid : "";
    const param = query.param ? JSON.parse(query.param) : null;
    const phoneNumber = param ? param.phonenumber : "";
    const app_id = (query.app_id !== undefined) ? query.app_id : 1

    let testCode = query.test_code;
    let lessonCode = query.lesson_code;
    let currCode = query.curr_code;
    let tryTime = query.try_time;
    const isOnline = useNetwork();
    let answersStorageKey = "";
    if (uuid && testCode) {
        answersStorageKey = `answers_${uuid}_${testCode}`;
    }
    if (uuid && lessonCode && currCode) {
        answersStorageKey = `answers_${uuid}_${currCode}_${lessonCode}`;
    }

    return (
        <React.Fragment>
            <BaseComponent {...props} uuid={uuid} phoneNumber={phoneNumber} testCode={testCode} lessonCode={lessonCode} currCode={currCode}
                           tryTime={tryTime} answersStorageKey={answersStorageKey} isOnline={isOnline}
                            app_id={app_id}
            />
        </React.Fragment>
    );
};

export default withUrlParams;
